/**
 * CODE
 */

/**
 * I format contact uid based on channel type
 *
 * :param channel: channel type
 * :param uid: contact uid
 *
 * :returns: formated contact uid
 */
function toDisplayable(channel: string, uid: string): string
{
    // convert channel to lower case
    const lowerChannel = channel.toLocaleLowerCase();

    // channel is whatsapp: return phone number
    if (lowerChannel === 'whatsapp')
    {
        return uid.replace('@c.us', '').replace('+', '');
    }

    // no need to format: return
    return uid;
}


/**
 * EXPORTS
 */
export default toDisplayable;
